import { useTranslation } from 'react-i18next';

import { mapCrossSectoralStandardToDisplayValue } from '../../helpers/cross-sectoral-standard-mapper';

type CrossSectoralStandardsProps = {
  standards: string[];
};

// Component to display the cross sectoral standards as plain text, comma separated
const CrossSectoralStandards = (props: CrossSectoralStandardsProps): JSX.Element => {
  const { standards } = props;

  const { t } = useTranslation();

  // Different backend values can map to the same label (e.g. ISO 14040 / 14044), so dedupe.
  const displayNames = Array.from(
    new Set(
      (standards ?? []).filter(Boolean).map((standardName) => {
        return mapCrossSectoralStandardToDisplayValue(standardName);
      }),
    ),
  );

  if (!displayNames.length) {
    return <span className='text-black-alpha-60'>{t('global.notSpecified')}</span>;
  }

  return <span className='text-black-alpha-60'>{displayNames.join(', ')}</span>;
};

export default CrossSectoralStandards;
